export default __webpack_public_path__ + "static/media/audio/cannon-shot-miss-splash.d4aefa5b88f75cc29b84eff43eb83377.mp3";